<div class="breadcrumb-container">
    <div class="breadcrumb-icon"><i [ngClass]="breadcrumbIcon"></i></div>
    <div class="breadcrumb-path">
        <p class="component-name">{{ breadcrumbHeader }}</p>
        <p class="component-path">{{ breadcrumbSubHeader | titlecase }}</p>
    </div>
</div>